import GLightbox from 'glightbox';

if (document.querySelector('.glightbox-product')) {
    const lightbox = GLightbox({
        selector: '.glightbox-product',
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        zoomable: true,
        draggable: true,
        plyr: {
            config: {
                ratio: '16:9', // or '4:3'
                muted: false,
                hideControls: true,
                youtube: {
                    noCookie: true,
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3,
                },
                vimeo: {
                    byline: false,
                    portrait: false,
                    title: false,
                    speed: true,
                    transparent: false,
                },
            },
        },
    });
}

if (document.querySelector('.glightbox-gallery')) {
    Array.from(document.querySelectorAll('.glightbox-gallery')).forEach((el) => {
        const lightbox = GLightbox({
            selector: `.${el.getAttribute('data-selector')}`,
            touchNavigation: true,
            loop: true,
            autoplayVideos: true,
            zoomable: true,
            draggable: true,
        });
    });
}
if (document.querySelector('.glightbox-testimony')) {
    Array.from(document.querySelectorAll('.glightbox-testimony')).forEach((el) => {
        const lightbox = GLightbox({
            selector: `.${el.getAttribute('data-selector')}`,
            touchNavigation: true,
            loop: true,
            autoplayVideos: true,
            zoomable: true,
            draggable: true,
        });
    });
}
